import { render } from "./SearchDocumentResults.vue?vue&type=template&id=202c52bb&scoped=true"
import script from "./SearchDocumentResults.vue?vue&type=script&lang=js"
export * from "./SearchDocumentResults.vue?vue&type=script&lang=js"

import "./SearchDocumentResults.vue?vue&type=style&index=0&id=202c52bb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202c52bb"]])

export default __exports__